import { C as CarouselManager } from "./carouselManager.aac5e7bb.chunk.js";
import { B as BookSeries, a as BookSeriesItemsForm, b as BookSeriesItem } from "./book-series.15fd8498.chunk.js";
import { G as GModal, a as GDropdown } from "./g-dropdown.fae1b620.chunk.js";
import { a as formatMoney, f as fetchRetailRecommendations } from "./g-utils.fc76ffa2.chunk.js";
import { G as GCarousel } from "./g-carousel.552b52b1.chunk.js";
document.addEventListener("DOMContentLoaded", (e) => {
  const bisSignupModal = document.querySelector("#bis-signup-modal");
  const bisSuccessModal = document.querySelector("#bis-success-modal");
  const bisSignupForm = bisSignupModal.querySelector("#bis-signup-form");
  const messagebox = bisSignupModal.querySelector("#messagebox");
  bisSignupForm.addEventListener("submit", async (e2) => {
    e2.preventDefault();
    const email = bisSignupForm.querySelector("#email").value;
    const variantInputs = bisSignupForm.querySelectorAll(".bis-variant");
    let variantChecks;
    if (variantInputs.length > 1) {
      variantChecks = Array.from(bisSignupForm.querySelectorAll(".bis-variant-check")).map(
        (input) => input.checked
      );
    } else {
      variantChecks = [true];
    }
    const variantsToSend = [];
    variantInputs.forEach((input, index) => {
      if (variantChecks[index]) {
        variantsToSend.push(input.value);
      }
    });
    if (variantsToSend.length == 0) {
      messagebox.classList.remove("jc-hidden");
      return;
    } else {
      messagebox.classList.add("jc-hidden");
    }
    const promises = [];
    variantsToSend.forEach((variant, index) => {
      const options = {
        method: "POST",
        headers: {
          accept: "application/json",
          revision: "2024-05-15",
          "content-type": "application/json"
        },
        body: JSON.stringify({
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email
                  }
                }
              },
              channels: ["EMAIL"]
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${variant}`
                }
              }
            }
          }
        })
      };
      promises.push(
        new Promise((resolve, reject) => {
          setTimeout(() => {
            fetch(
              "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=WMA94z",
              options
            ).then((response) => {
              if (response.ok) {
                resolve(response);
              } else {
                reject(response);
              }
            });
          }, 2e3 * index);
        })
      );
      Promise.any(promises).then((result) => {
        bisSignupModal.close();
        bisSuccessModal.open();
      }).catch((error) => error);
    });
  });
});
class ProductGallery extends HTMLElement {
  constructor() {
    super();
  }
  async connectedCallback() {
    await this.initSlider();
    this.initSliderArrows();
  }
  async initSlider() {
    const splideEl = this.querySelector(".splide");
    let options = {
      type: "fade",
      perPage: 1,
      pagination: true,
      arrows: false
    };
    this.splide = await CarouselManager.create(splideEl, options);
    if (this.dataset.lazyloadSection === "true") {
      await this.fetchItems();
      if (this.splide) {
        this.splide.refresh();
      }
    }
    if (this.dataset.arrows === "true") {
      this.initSliderArrows();
    }
    this.classList.add("js-loaded");
  }
  initSliderArrows() {
    const sliderNavEl = this.querySelector(".slider-nav");
    if (sliderNavEl) {
      const navNextBtn = sliderNavEl.querySelector(".nav-next");
      const navPrevBtn = sliderNavEl.querySelector(".nav-prev");
      const maxIndex = () => {
        const maxIndex2 = this.splide.Components.Controller.getEnd() - this.visibleSlides + 1;
        const currentIndex = this.splide.Components.Controller.getIndex();
        if (maxIndex2 === currentIndex) {
          return true;
        } else if (maxIndex2 < currentIndex) {
          this.splide.Components.Controller.setIndex(maxIndex2);
          return true;
        } else {
          return false;
        }
      };
      navNextBtn.addEventListener("click", () => {
        if (maxIndex())
          return;
        this.splide.go(">");
      });
      navPrevBtn.addEventListener("click", () => {
        maxIndex();
        this.splide.go("<");
      });
    } else {
      console.warn("No slider nav found");
    }
  }
  get visibleSlides() {
    if (!this.splide)
      return 1;
    if (!this._visibleSlides || this._windowWidth !== window.innerWidth) {
      this._windowWidth = window.innerWidth;
      this._visibleSlides = this.splide.root.querySelectorAll(".splide__slide.is-visible").length;
    }
    return this._visibleSlides;
  }
}
customElements.define("product-gallery", ProductGallery);
document.addEventListener("DOMContentLoaded", (e) => {
  var _a;
  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }
  const sideModal = document.querySelector("#description-modal");
  const openSideModalBtns = document.querySelectorAll(".js-open-side-modal");
  openSideModalBtns.forEach(
    (btn) => sideModal.addOpenTrigger("click", btn, btn.dataset.modalContentKey)
  );
  if (isIOS()) {
    document.querySelectorAll('[data-modal-selector="#read-extract"]').forEach((button) => button.remove());
    (_a = document.querySelector("#read-extract")) == null ? void 0 : _a.remove();
  }
});
class SeriesCarouselModal extends GModal {
  constructor() {
    super();
    this.form = this.querySelector("form");
  }
  open() {
    const result = super.open();
    this.items.forEach((item) => item.enable());
    this.form.dispatchEvent(new CustomEvent("series-carousel-items:update"));
    return result;
  }
  get items() {
    return this.querySelectorAll("series-carousel-item");
  }
}
class SeriesCarousel extends BookSeries {
  constructor() {
    super();
    this.modal = this.querySelector("series-carousel-modal");
    this.init = false;
  }
  async connectedCallback() {
    super.connectedCallback();
    this._initSlider();
    this.cart.addEventListener("cart:rerendered", (e) => {
      clearTimeout(this.cartTimoutId);
      this.cartTimoutId = setTimeout(this._fetchItems.bind(this), 1e3);
    });
    this.querySelectorAll(".js-open-series-modal").forEach(
      (button) => this.modal.addOpenTrigger("click", button)
    );
    this.querySelectorAll(".js-close-series-modal").forEach(
      (button) => this.modal.addCloseTrigger("click", button)
    );
  }
  async _updateContent() {
    var _a, _b, _c;
    this.setAttribute("aria-busy", true);
    const carouselItems = this.querySelector(".js-carousel-items");
    const modalItems = this.querySelector(".js-modal-items");
    const totalPriceEls = this.querySelectorAll(".js-total-price");
    const booksCountEls = this.querySelectorAll(".js-books-count");
    const newCarouselItems = document.createElement("DIV");
    const newModalItems = document.createElement("DIV");
    let newTotalPrice = 0;
    let newBooksCount = 0;
    for (const batch of this._sectionBatches) {
      const curCarouselItems = batch.querySelector(".js-carousel-items");
      const curModalItems = batch.querySelector(".js-modal-items");
      const curTotalPrice = parseInt((_a = batch.querySelector(".js-total-price")) == null ? void 0 : _a.dataset.totalPrice) || 0;
      const curBooksCount = parseInt((_b = batch.querySelector(".js-books-count")) == null ? void 0 : _b.dataset.booksCount) || 0;
      newCarouselItems.insertAdjacentHTML("beforeend", curCarouselItems.innerHTML);
      newModalItems.insertAdjacentHTML("beforeend", curModalItems.innerHTML);
      newTotalPrice += curTotalPrice;
      newBooksCount += curBooksCount;
    }
    if (Number.parseInt(newBooksCount) === 0) {
      this.setAttribute("aria-hidden", true);
      return;
    } else {
      this.setAttribute("aria-hidden", false);
    }
    if (!this.init) {
      carouselItems.innerHTML = newCarouselItems.innerHTML;
      (_c = this.swiper) == null ? void 0 : _c.update();
      this.init = true;
    }
    if (this.splide) {
      this.splide.refresh();
    }
    modalItems.innerHTML = newModalItems.innerHTML;
    totalPriceEls.forEach((el) => el.textContent = formatMoney(newTotalPrice));
    booksCountEls.forEach((el) => el.textContent = newBooksCount);
    this.setAttribute("aria-busy", false);
  }
  async _initSlider() {
    this.splideEl = this.querySelector(".splide");
    let options = {
      arrows: false,
      drag: "free",
      pagination: false,
      perPage: 5,
      authHeight: true,
      gap: 16,
      breakpoints: {
        640: {
          destroy: true
        },
        768: {
          perPage: 3
        },
        900: {
          perPage: 2
        },
        1140: {
          perPage: 3
        },
        1280: {
          perPage: 4
        }
      }
    };
    this.splide = await CarouselManager.create(this.splideEl, options);
    this._initWheel();
    if (this.dataset.arrows === "true") {
      this._initSliderArrows();
    }
  }
  _initWheel() {
    let lastTime = 0;
    const min = this.splide.options.wheelMinThreshold || 0;
    const sleep = this.splide.options.wheelSleep || 80;
    this.splideEl.addEventListener("wheel", (e) => {
      if (window.innerWidth < 640)
        return;
      if (e.cancelable) {
        let delta = e.deltaX;
        if (e.shiftKey && delta === 0) {
          delta = e.deltaY;
        }
        const backwards = delta < 0;
        const timeStamp = Date.now();
        if (Math.abs(delta) > min && timeStamp - lastTime > sleep) {
          this.splide.go(backwards ? "<" : ">");
          lastTime = timeStamp;
          e.preventDefault();
        }
      }
    });
  }
  _initSliderArrows() {
    const sliderNavEl = this.querySelector(".slider-nav");
    if (sliderNavEl) {
      const navNextBtn = sliderNavEl.querySelector(".nav-next");
      const navPrevBtn = sliderNavEl.querySelector(".nav-prev");
      const maxIndex = () => {
        const maxIndex2 = this.splide.Components.Controller.getEnd() - this.visibleSlides + 1;
        const currentIndex = this.splide.Components.Controller.getIndex();
        if (maxIndex2 === currentIndex) {
          return true;
        } else if (maxIndex2 < currentIndex) {
          this.splide.Components.Controller.setIndex(maxIndex2);
          return true;
        } else {
          return false;
        }
      };
      navNextBtn.addEventListener("click", () => {
        if (maxIndex())
          return;
        this.splide.go(">");
      });
      navPrevBtn.addEventListener("click", () => {
        maxIndex();
        this.splide.go("<");
      });
    } else {
      console.warn("No slider nav found");
    }
  }
  get visibleSlides() {
    if (!this.splide)
      return 1;
    if (!this._visibleSlides || this._windowWidth !== window.innerWidth) {
      this._windowWidth = window.innerWidth;
      this._visibleSlides = this.splide.root.querySelectorAll(".splide__slide.is-visible").length;
    }
    return this._visibleSlides;
  }
  get productId() {
    return this.dataset.productId;
  }
}
class SeriesCarouselItemsForm extends BookSeriesItemsForm {
  constructor() {
    super();
    this.modal = this.closest("series-carousel-modal");
    this.totalPriceEl = this.querySelector(".js-total-price");
    this.booksCountEl = this.querySelector(".js-books-count");
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("series-carousel-items:update", this._onUpdate.bind(this));
  }
  async _addToCart() {
    const items = this.querySelectorAll('.js-series-item[aria-disabled="false"]');
    const datalayerItems = new Array();
    const klaviyoItems = new Array();
    const atcItems = new Array();
    items.forEach((item) => {
      var _a, _b;
      datalayerItems.push(item.atcDatalayer);
      klaviyoItems.push(item.atcKlaviyoEventData);
      const properties = {
        Auteur: item.author
      };
      if ((_a = this._collection) == null ? void 0 : _a.title) {
        properties._collectionTitle = item.collection.title;
      }
      if ((_b = this._collection) == null ? void 0 : _b.id) {
        properties._collectionId = item.collection.id;
      }
      atcItems.push({
        id: Number.parseInt(item.variantId),
        quantity: 1,
        properties
      });
    });
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ items: atcItems })
      });
      if (response.ok) {
        this.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              button: this,
              variant: null,
              quantity: atcItems.length
            }
          })
        );
        datalayerItems.forEach((item) => {
          window.dataLayer.push({
            "cloud_retail": ""
          });
          window.dataLayer.push(item);
        });
        klaviyoItems.forEach((item, index) => {
          setTimeout(() => {
            console.log("push item", item);
            window.jollyFunctions.klaviyoTrackAddToCart(item);
          }, index * 1e3);
        });
      }
    } catch (error) {
      console.error(error.message);
    }
  }
  async _onSubmit(e) {
    e.preventDefault();
    this.modal.close();
    await this._addToCart();
  }
  _onUpdate(e) {
    let amount = 0;
    let count = 0;
    Array.from(this.querySelectorAll("series-carousel-item")).filter((item) => item.getAttribute("aria-disabled") === "false").forEach((item) => {
      amount += Number.parseInt(item.dataset.price);
      count++;
    });
    if (this.totalPriceEl) {
      this.totalPriceEl.textContent = formatMoney(amount);
    }
    if (this.booksCountEl) {
      this.booksCountEl.textContent = count;
    }
  }
}
class SeriesCarouselItem extends BookSeriesItem {
  constructor() {
    super();
    this.removeButton = this.querySelector(".js-remove-item");
  }
  connectedCallback() {
    this.removeButton.addEventListener("click", this._onRemoveButtonClick.bind(this));
  }
  _onRemoveButtonClick(e) {
    const disable = this.form.querySelectorAll('series-carousel-item:not([aria-disabled="true"])').length > 1;
    if (disable) {
      this.disable();
      this.form.dispatchEvent(new CustomEvent("series-carousel-items:update", { bubbles: true }));
    }
  }
  get atcDatalayer() {
    const ga_add_to_cart = {
      "event": "ga_add_to_cart",
      "cloud_retail": {
        "eventType": "add-to-cart",
        "attributionToken": sessionStorage.getItem("attributionToken") ? sessionStorage.getItem("attributionToken") : null,
        "visitorId": localStorage.getItem("visitorId"),
        "productDetails": [{
          "product": {
            "id": `${this.dataset.barcode}`
          },
          "quantity": 1
        }],
        "cartId": `${window.cartToken}`,
        "userInfo": {
          "userId": `${window.userId}`
        }
      },
      "productDetails": [{
        "product": {
          "id": `${this.dataset.barcode}`,
          "L1_main_category": `${this.dataset.l1}`,
          "L2_main_category": `${this.dataset.l2}`,
          "pricing_group": `${this.dataset.pricingGroup}`,
          "pricing_stage": `${this.dataset.pricingStage}`
        },
        "quantity": 1
      }]
    };
    if (this.dataset.carouselId) {
      ga_add_to_cart.productDetails[0].product.carousel_id = parseInt(this.dataset.carouselId);
    }
    if (this.dataset.carouselName) {
      ga_add_to_cart.productDetails[0].product.carousel_name = this.dataset.carouselName;
    }
    if (this.dataset.positionInCarousel) {
      ga_add_to_cart.productDetails[0].product.position_in_carousel = parseInt(this.dataset.positionInCarousel);
    }
    return ga_add_to_cart;
  }
}
class SeriesItemStateSelector extends GDropdown {
  constructor() {
    super();
    this.itemEl = this.closest("series-carousel-item");
    this.variantPrices = JSON.parse(this.itemEl.querySelector("#variant-prices").innerHTML);
    this.itemPriceEl = this.itemEl.querySelector(".js-item-price");
  }
  connectedCallback() {
    this.addEventListener("click", (e) => {
      if (this.getAttribute("aria-expanded") === "false") {
        this.open();
      } else {
        this.close();
      }
    });
    this._items.forEach(
      (item) => item.addEventListener("click", (e) => {
        this.value = item.dataset.value;
      })
    );
    window.addEventListener("click", (e) => {
      if (e.target.closest("series-item-state-selector") != this) {
        this.close();
      }
    });
  }
  set value(value) {
    super.value = value;
    this.itemPriceEl.textContent = formatMoney(this.variantPrices[value]);
    this.itemEl.dataset.price = this.variantPrices[value];
    this.dispatchEvent(new CustomEvent("series-carousel-items:update", { bubbles: true }));
  }
}
window.customElements.define("series-carousel-modal", SeriesCarouselModal);
window.customElements.define("series-carousel", SeriesCarousel);
window.customElements.define("series-carousel-items-form", SeriesCarouselItemsForm, {
  extends: "form"
});
window.customElements.define("series-carousel-item", SeriesCarouselItem);
window.customElements.define("series-item-state-selector", SeriesItemStateSelector);
class ProductRecommendations extends GCarousel {
  constructor() {
    super();
    this.useCustomRecommendation = this.getAttribute("data-use-custom-recommendation") || null;
    this.productIsbn = this.getAttribute("data-recommendation-product-isbn") || null;
    this.dynamic = true;
  }
  async fetchCustomRecommendations() {
    const productData = [{
      primaryProductId: this.productIsbn
    }];
    const response = await fetchRetailRecommendations({
      type: "product_page",
      products: productData,
      pageSize: void 0
    });
    const productIsbns = response.result.products.map((product) => product.isbn).join(",");
    return productIsbns;
  }
  async fetchItems() {
    let url;
    if (this.useCustomRecommendation === "true") {
      const fetchedProductsIsbns = await this.fetchCustomRecommendations();
      url = `/search/?section_id=${this.sectionId}&product_ids=${fetchedProductsIsbns}`;
    } else {
      url = `${window.routes.productRecommendationsUrl}?section_id=${this.sectionId}&product_id=${this.productId}&limit${this.recommendationsCount}`;
    }
    const response = await fetch(url);
    const text = await response.text();
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text;
    const newSplideList = tempDiv.querySelector(".splide__list");
    if (newSplideList.childElementCount > 0) {
      this.splideList.innerHTML = newSplideList.innerHTML;
    } else {
      this.setAttribute("aria-hidden", true);
    }
    if (this.splide) {
      this.splide.refresh();
    }
  }
  get sectionId() {
    return this.dataset.sectionId;
  }
  get productId() {
    return this.dataset.productId;
  }
  get recommendationsCount() {
    return Number(this.dataset.recommendationsCount);
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class GoFurther extends GCarousel {
  constructor() {
    super();
    this.observer = null;
    this.dynamic = true;
  }
  async fetchItems() {
    if (!this.isbn) {
      this.setAttribute("aria-hidden", true);
      return;
    }
    try {
      const recommendationsJson = await fetchRetailRecommendations({
        type: "go_further",
        products: [
          {
            primaryProductId: this.isbn
          }
        ],
        pageSize: this.recommendationsCount
      });
      if (!(recommendationsJson == null ? void 0 : recommendationsJson.result.products) || (recommendationsJson == null ? void 0 : recommendationsJson.result.products.length) === 0) {
        this.setAttribute("aria-hidden", true);
        return;
      }
      const productIds = recommendationsJson.result.products.map((opus) => opus.isbn);
      let sectionUrl = `?sections=ajax-go-further-v2-items&product_ids=${productIds}`;
      if (this.dataset.carouselId) {
        sectionUrl += `&carousel_id=${this.dataset.carouselId}`;
      }
      if (this.dataset.carouselName) {
        sectionUrl += `&carousel_name=${encodeURI(this.dataset.carouselName)}`;
      }
      const sectionResponse = await fetch(window.Shopify.routes.root + sectionUrl);
      const sectionJson = await sectionResponse.json();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = sectionJson[Object.keys(sectionJson)[0]];
      const items = tempDiv.querySelector(".js-content");
      if (items && items.childElementCount > 0) {
        this.splideList.innerHTML = items.innerHTML;
        this.setAttribute("aria-hidden", false);
      } else {
        this.setAttribute("aria-hidden", true);
      }
      if (this.splide) {
        this.splide.refresh();
      }
    } catch (error) {
      console.error("Error fetching recommendations:", error);
      this.setAttribute("aria-hidden", true);
      return;
    }
  }
  get sectionId() {
    return this.dataset.sectionId;
  }
  get isbn() {
    return this.dataset.isbn;
  }
  get recommendationsCount() {
    return Number(this.dataset.recommendationsCount);
  }
}
customElements.define("go-further", GoFurther);
(() => {
  const stickyAddToCartMob = document.querySelector(".js-sticky-atc");
  document.body.style.setProperty(
    "--offsetPaddingBottom",
    stickyAddToCartMob.offsetHeight + "px"
  );
})();
//# sourceMappingURL=jc-bundle-product.js.map
